import React, { useState } from "react";
import styled from "styled-components";
import { Cookies } from "react-cookie";
import { PRIMARY_COLOR } from "../../const";
import { useNavigate } from "react-router-dom";

const LoginBox = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;
const InputArea = styled.div`
    width: 180px;
    height: 40px;
    border: 2px solid ${PRIMARY_COLOR};
    border-radius: 12px;

    position: relative;

    margin-bottom: 12px;

    & label {
        position: absolute;
        left: 4px;
        font-size: 14px;
        top: calc(50% - 10px);
        transition: 0.4s;
    }

    & input {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        background-color: transparent;
        padding-left: 8px;
    }

    & input:focus ~ .label {
        top: 0;
    }
`;
const LoginButton = styled.button`
    /* background-color: ${PRIMARY_COLOR}; */
    position: relative;
    &::before {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: ${PRIMARY_COLOR};
        content: '';
        z-index: 0;
        transition: 0.3s;
    }
    &::after {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        line-height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        /* background-color: ${PRIMARY_COLOR}; */
        color: white;
        content: '로그인';
        z-index: 1;
    }

    z-index: 1;

    width: 180px;
    color: white;
    background-color: white;
    height: 40px;
    border: 2px solid ${PRIMARY_COLOR};
    border-radius: 12px;
    box-sizing: border-box;
    cursor: pointer;

    overflow: hidden;

    &:hover {
        &::before {
            transform: translateX(100%);
        }

        &::after {
            color: ${PRIMARY_COLOR};
        }
    }
`;

const Login = () => {
    const cookies = new Cookies();
    const navigate = useNavigate();
    const [user, setUser] = useState("");
    const [password, setPassword] = useState("");
    const onLogin = () => {
        if(user !== "admin") return;
        cookies.set("user", user);
        navigate('/');
    }
    const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if(e.key === "Enter") {
            onLogin();
        }
    }
    return (
        <LoginBox>
            <InputArea>
                <input type="text" value={user} onChange={(e) => setUser(e.target.value)} placeholder="아이디" />
            </InputArea>
            <InputArea>
                <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="비밀번호" onKeyDown={onKeyDown} />
            </InputArea>
            <LoginButton onClick={onLogin}>로그인</LoginButton>
        </LoginBox>
    );
};

export default Login;